// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\PostalAddress\ApiPostalAddress.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Country, CountryData, CountryOptions } from 'data/models/Country';

// PostalAddressData is the class that PostalAddress serializes to/from
export interface PostalAddressData {
    Id : number;
    Url : string | null;
	
    Country : CountryData | null;
    CountryId : number;
    OrganizationId : number | null;
    UserId : number | null;
	
    Address : string;
    AptSte : string | null;
    City : string;
    Guid : /* GUID */ string;
    PostalCode : string;
    StateProv : string;
}

// PostalAddressOptions is the class which may be passed to the PostalAddress constructor to define optional initial data values
export interface PostalAddressOptions {
    Id : number;
    Url? : string | null;
	
    Country? : CountryOptions | null;
    CountryId? : number;
    OrganizationId? : number | null;
    UserId? : number | null;
	
    Address? : string;
    AptSte? : string | null;
    City? : string;
    Guid? : /* GUID */ string;
    PostalCode? : string;
    StateProv? : string;
}

export class PostalAddress {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public Country : DataSignal<Country | null>;
    public CountryId : DataSignal<number>;
    public OrganizationId : DataSignal<number | null>;
    public UserId : DataSignal<number | null>;
	
    public Address : DataSignal<string>;
    public AptSte : DataSignal<string | null>;
    public City : DataSignal<string>;
    public Guid : DataSignal<string>;
    public PostalCode : DataSignal<string>;
    public StateProv : DataSignal<string>;

    constructor();
    constructor(data : PostalAddressOptions);
    constructor(data: PostalAddressOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.Country = S.value<Country | null>(null);
        this.CountryId = jsonableObservable(S.value<number>(data && data.CountryId !== undefined ? data.CountryId : 0));
        this.OrganizationId = jsonableObservable(S.value<number | null>(data && data.OrganizationId !== undefined ? data.OrganizationId : null));
        this.UserId = jsonableObservable(S.value<number | null>(data && data.UserId !== undefined ? data.UserId : null));
	    
        this.Address = jsonableObservable(S.value<string>(data && data.Address !== undefined ? data.Address : ''));
        this.AptSte = jsonableObservable(S.value<string | null>(data && data.AptSte !== undefined ? data.AptSte : null));
        this.City = jsonableObservable(S.value<string>(data && data.City !== undefined ? data.City : ''));
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.PostalCode = jsonableObservable(S.value<string>(data && data.PostalCode !== undefined ? data.PostalCode : ''));
        this.StateProv = jsonableObservable(S.value<string>(data && data.StateProv !== undefined ? data.StateProv : ''));
    }

    static key(obj : PostalAddress) {
        return obj.Id();
    }
    
    static dataKey(obj : PostalAddressOptions) {
        return obj.Id;
    }

    static update(obj : PostalAddress, data : PostalAddressOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
            if (data.CountryId !== undefined) obj.CountryId(data.CountryId);
            if (data.OrganizationId !== undefined) obj.OrganizationId(data.OrganizationId);
            if (data.UserId !== undefined) obj.UserId(data.UserId);
	        
            if (data.Address !== undefined) obj.Address(data.Address);
            if (data.AptSte !== undefined) obj.AptSte(data.AptSte);
            if (data.City !== undefined) obj.City(data.City);
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.PostalCode !== undefined) obj.PostalCode(data.PostalCode);
            if (data.StateProv !== undefined) obj.StateProv(data.StateProv);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PostalAddress.ts